import "./RoomStatusBar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBed, faCheckCircle, faBroom, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

interface RoomStatusProps {
  roomStatus: {
    ready: number;
    occupied: number;
    dirty: number;
    cleaning: number;
    outOfService: number;
    total?: number;
  };
}

export default function RoomStatusBar({ roomStatus }: RoomStatusProps) {
  const { ready, occupied, dirty, cleaning, outOfService } = roomStatus;
  const total = (roomStatus.total ?? (ready + occupied + dirty + cleaning + outOfService)) || 1;

  const items = [
    { icon: faBed,                  label: "Occupied",       value: occupied,      color: "#6366f1", bg: "rgba(99,102,241,0.12)" },
    { icon: faCheckCircle,          label: "Ready",          value: ready,         color: "#10b981", bg: "rgba(16,185,129,0.12)" },
    { icon: faTriangleExclamation,  label: "Dirty",          value: dirty,         color: "#ef4444", bg: "rgba(239,68,68,0.10)" },
    { icon: faBroom,                label: "Cleaning",       value: cleaning,      color: "#f59e0b", bg: "rgba(245,158,11,0.12)" },
    { icon: faTriangleExclamation,  label: "Out of Service", value: outOfService,  color: "rgba(242,235,217,0.3)", bg: "rgba(148,163,184,0.12)" },
  ];

  return (
    <div className="rsb-root">
      <div className="rsb-header">
        <h3 className="rsb-title">Room Status Snapshot</h3>
        <span className="rsb-total">{total} rooms total</span>
      </div>

      {/* Progress bar */}
      <div className="rsb-bar">
        {items.map((item, i) => (
          <div
            key={i}
            className="rsb-bar-seg"
            style={{
              width: `${(item.value / total) * 100}%`,
              background: item.color,
            }}
            title={`${item.label}: ${item.value}`}
          />
        ))}
      </div>

      {/* Stat tiles */}
      <div className="rsb-tiles">
        {items.map((item, i) => (
          <div key={i} className="rsb-tile" style={{ borderColor: item.color + "33" }}>
            <div className="rsb-tile-icon" style={{ background: item.bg, color: item.color }}>
              <FontAwesomeIcon icon={item.icon} />
            </div>
            <div className="rsb-tile-info">
              <span className="rsb-tile-val" style={{ color: item.color }}>{item.value}</span>
              <span className="rsb-tile-label">{item.label}</span>
            </div>
            <div className="rsb-tile-pct">{Math.round((item.value / total) * 100)}%</div>
          </div>
        ))}
      </div>
    </div>
  );
}
